import React, { type ReactNode, useMemo } from 'react'

type Props = {
	space: number
	units?: string
	children: ReactNode
}

export default function MarginComponent({ space, units = 'rem', children }: Props): React.ReactNode {
	const style = useMemo(
		() => ({
			margin: space + units,
		}),
		[space, units],
	)
	return React.Children.map(children, child => {
		if (!React.isValidElement(child)) return child
		return React.cloneElement(child as React.ReactElement<any>, {
			style: style,
		})
	})
}
